module.exports = __webpack_public_path__ + "img/icon_mark_sport.84e454ea.png";